<template>
  <div
    class="topTile-base"
    :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }"
  >
    <div class="topTile-left-title">
      <img
        src="../../assets/images/qcyn-titile-bg.png"
        alt="七彩云南智选地，云南省建设用地招商云平台"
      />
      <!-- <div class="app-name-span1">{{ appName }}</div>
      <div class="app-name-span3">{{ siteShortTitle }}</div> -->
      <!-- <div class="app-name-span2">{{ appDescribe }}</div> -->
    </div>
    <div class="toptile-right-search">
      <el-input
        v-model="searchWord"
        class="se-input"
        size="mini"
        clearable
        placeholder="请输入搜索内容"
      ></el-input>

      <img
        id="seButton"
        class="se-button"
        style="width: 36px; height: 36px; cursor: pointer"
        src="@/assets/images/index-search-bg.png"
        alt=""
        @click="search"
      />
      <!-- <el-button
        id="seButton"
        class="se-button"
        size="mini"
        type="primary"
        icon="el-icon-search"
        @click="search"
        >搜索</el-button
      > -->
      <div class="mask-box scrollbar-definition" v-if="searchWord && isSearch">
        <div
          class="mask-box-li"
          v-for="(item, index) in list"
          :key="index"
          @click="goUrl(item)"
        >
          <div class="mask-box-li-l">
            <i class="el-icon-s-promotion"></i>
          </div>
          <div class="mask-box-li-c">
            {{ item.name || item.code }}
          </div>
          <div
            :class="['mask-box-li-r', item.type == 2 ? 'font-c1' : 'font-c2']"
          >
            {{ item.typeName }}
          </div>
        </div>
      </div>
      <div
        class="mask-box scrollbar-definition"
        v-if="searchWord && isSearch && !list.length"
      >
        <div class="mask-span">暂无数据</div>
      </div>
    </div>
  </div>
</template>

<script>
import { searchKey } from "@/api/setting/investment";
export default {
  name: "topTitle",
  data() {
    return {
      appName: systemConfig.siteTitle,
      appDescribe: systemConfig.siteDescribe,
      siteShortTitle: systemConfig.siteShortTitle,
      searchWord: "",
      list: [],
      isSearch: false,
      screenIndexWidth: null,
    };
  },
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
    document.addEventListener("click", (e) => {
      if (
        e.target._prevClass != "el-icon-search" &&
        e.target.id != "seButton" &&
        e.target.innerText != "搜索"
      ) {
        this.isSearch = false;
      }
    });
  },
  methods: {
    search() {
      this.isSearch = true;
      searchKey({ keyName: this.searchWord }).then((res) => {
        if (res.data.success) {
          this.list = res.data.data;
        }
      });
    },
    goUrl(data) {
      if (data.type == 1) {
        // this.$router.push({
        //   path: "/black",
        //   query: { path: "/parkDetail", id: data.id },
        // });
        // this.$router.push({ path: "/parkDetail", query: { id: data.id } });
        this.$router.replace({ path: "/parkDetail", query: { id: data.id } });
      } else if (data.type == 2) {
        // this.$router.push({
        //   path: "/black",
        //   query: { path: "/land/detail", id: data.id },
        // });
        this.$router.push({ path: "/land/detail", query: { id: data.id } });
      } else {
        // this.$router.push({
        //   path: "/black",
        //   query: { path: "/project/detail", id: data.id },
        // });

        this.$router.push({
          path: "/project/detail",
          query: { id: data.id },
        });
      }
    },
  },
};
</script>

<style scoped>
.topTile-base {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 150px;
}

.toptile-right-search {
  width: 317px;
  position: relative;
  display: flex;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 16px;
  align-items: center;
  justify-content: space-between;
  /* right: -400px; */
}
.mask-box {
  width: 298px;
  background: #fff;
  border-radius: 10px;
  padding: 0 10px;
  position: absolute;
  top: 55px;
  box-shadow: 0px 10px 21px 0px rgba(12, 55, 124, 0.302);
  z-index: 99;
  max-height: 260px;
  overflow-y: auto;
}
.mask-span {
  font-size: 14px;
  padding: 20px 80px;
}
.mask-box-li {
  padding: 15px 0;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  font-size: 14px;
  letter-spacing: 2px;
}
.mask-box-li-l {
  width: 30px;
  border-radius: 50%;
  background: #f8f7fb;
  font-size: 20px;
  text-align: center;
  color: #92a3b0;
}
.mask-box-li-c {
  height: 30px;
  line-height: 30px;
  width: 200px;
  margin: 0 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.mask-box-li-r {
  height: 20px;
  width: 50px;
  text-align: center;
  border-radius: 6px;
  margin: auto 0;
}
.font-c1 {
  background: #fcf0d5;
  color: #b58932;
}
.font-c2 {
  background: #c9e9ff;
  color: #33a5eb;
}
.se-input {
  width: 270px;
  /* width: calc(280px - 100px); */
}

>>> .se-input .el-input__inner {
  /* border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px; */
  width: 270px;
  height: 40px;
  /* width: calc(280px - 100px); */
  /* background: red; */
  background-color: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 16px;
}
>>> .se-input .el-input__inner:focus {
  outline: none;
  outline: 0;
}

.se-button {
  height: 40px;
  border-radius: 16px;
  width: 100%;
  margin-right: 10px;
  /* border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px; */
  background-color: rgba(255, 255, 255, 0.7);
}
.app-name-span3 {
  font-size: 23px;
  font-weight: 600;
  color: #0f62b5;
  /* text-shadow: 1px 1px black; */
}
.app-name-span1 {
  font-weight: 600;
  color: #0f62b5;
  margin-bottom: 5px;
  letter-spacing: 1px;
}

.app-name-span2 {
  color: #ffffff;
  margin-bottom: 35px;
  letter-spacing: 1px;
  font-size: 15px;
  width: 587px;
  font-weight: bold;
  text-shadow: 1px 1px black;
}
.topTile-left-title img {
  /* transform: scale(1.1); */
}
</style>
